/**
 * Auto-generated from dark-roast DAOs (com.axiom.db.models.dao).
 * Shared by all Java backends — do not edit manually.
 * Regenerate with: yarn sync-entities
 */

import { Entity } from '@data-client/rest';
import { Industry } from '../enums/industry';
export class CandidateIndustryEntity extends Entity {
  candidateId: string | null = null;
  createdAt: string | null = null;
  id: string = '';
  industryValue: Industry | null = null;
  updatedAt: string | null = null;
  yearsOfExperience: number | null = null;
  static override key = 'CandidateIndustry';
  static override schema = {};
  static override toJSON() {
    return { name: this.name, schema: {}, key: this.key };
  }
  static override process(input: unknown): unknown {
    if (
      input !== null &&
      typeof input === 'object' &&
      'CandidateIndustry' in input
    ) {
      const { CandidateIndustry: wrapped, ...rest } = input as {
        CandidateIndustry: object;
      } & object;
      return { ...(wrapped as object), ...rest };
    }
    return input;
  }
}